import gql from 'graphql-tag';

export default gql`
subscription {
    onDeleteCampaign {
        __typename
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Campaigns/DeleteSubscription.js